import { authInstance, noAuthInstance } from './axios/index';
import qs from 'qs';

const standardService = {
  //호텔 조회 AutoComplete
  getNations: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/national/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return noAuthInstance(requestOptions);
  },
  //호텔 직무 유형 코드 조회
  getHotelJobType: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/job-type/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 은행 목록
  getBankList: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/bank/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 공공시설 항목 목록
  getHotelPublicFacilities: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/public-facility/list?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 주변관광지 항목 목록
  getHotelLocations: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/location/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 서비스 종류
  getHotelServiceTypes: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/service/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 타입 조회
  getHotelRoomTypes: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/room-item/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 배드타입 조회
  getHotelBedItems: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/room-bed-item/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 전망 항목
  getHotelRoomViewItems: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/room-view-item/list?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 내 시설 항목
  getHotelRoomFacilityItems: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/room-facility-item/list?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  //호텔 객실 요금 그룹 목록
  getHotelRoomRateGroups: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/hotel/room-rate-group-type/list?${qs.stringify(
        params,
      )}`,
    };
    return authInstance(requestOptions);
  },
  // 여행사 직무유형
  getTravelJobTypes: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/travel/job-type/list?${qs.stringify(params, {
        arrayFormat: 'repeat',
      })}`,
    };
    return authInstance(requestOptions);
  },
  // 결제 방법 기준데이터 가져오기
  getPaymentTypes: () => {
    const requestOptions = {
      method: 'GET',
      url: `/api/manage/v1/std/travel/payment-types`,
    };
    return authInstance(requestOptions);
  },
};

export default standardService;
